import { createThunkRoutine } from 'redux-thunk-routine';
import { FETCH_APPLICATIONS } from './action-types';

export const FetchApplicationsRoutine = createThunkRoutine(FETCH_APPLICATIONS);
